import {PanelConfigurationNonWorkingDay, PanelConfigurationNonWorkingDayModel} from './panelConfigurationNonWorkingDay.model';
import {BusinessProcessDimension} from './businessProcessDimension.model';
import {StateDimension} from './stateDimension.model';

export class PanelConfigurationIndicatorWorkingDay {
  businessProcessDimension: BusinessProcessDimension;
  stateDimensions: Array<StateDimension>;
  workingDays: Array<PanelConfigurationIndicatorWorkingDayItem>;
  nonWorkingDays: Array<PanelConfigurationNonWorkingDayModel>;
}

export class PanelConfigurationIndicatorWorkingDayItem {
  id: number;
  dayOfWeek: number;
  initialTime: Date;
  finalTime: Date;
  formatedInitialTime: string;
  formatedFinalTime: string;
}
